// extracted by mini-css-extract-plugin
module.exports = {"smallHeader":"styles_smallHeader__6lawe","smallHeaderNav":"styles_smallHeaderNav__JN6jN","smallHeaderItem":"styles_smallHeaderItem__wApnF"};